module.exports = __webpack_public_path__ + "media/images/download_icon-948b8ab8389c94b4f13635cefd01b5f7.svg";